<template>
  <div class="asta-tavolo-griglia">
    <calciatore-battuto
      :id="asta_round.calciatoreInAsta"
      v-if="asta_round.calciatoreInAsta"
    ></calciatore-battuto>

    <draggable
      v-model="asta_squadre_drag"
      :disabled="!this.admin || this.isAstaInCorso"
      ghost-class="ghost"
      animation="150"
      group="squadre-tavolo"
      delay="80"
      delayOnTouchOnly="true"
    >
      <transition-group class="lista-squadre">
        <div v-for="sq in asta_squadre_array" :key="sq.id">
          <squadra-tavolo
            :id="sq.id"
            :size="squadreSize"
          ></squadra-tavolo>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import db from "../js/db";
import Vuex from "vuex";
import draggable from "vuedraggable";
import SquadraTavolo from "./common/SquadraTavolo";
import CalciatoreBattuto from "./common/CalciatoreBattuto";
import mixins from "../js/mixins";

export default {
  name: "asta-tavolo-griglia",
  mixins: [mixins],
  components: {
    draggable,
    SquadraTavolo,
    CalciatoreBattuto,
  },
  computed: {
    asta_squadre_drag: {
      get() {
        return this.asta_squadre_array;
      },
      set(value) {
        for (var i = 0; i < value.length; i++) {
          let squadra = value[i];
          if (squadra.order != i + 1) {
            db.setOrdineSquadra(squadra.id, i + 1);
          }
        }
      },
    },
    ...Vuex.mapGetters([
      "asta_squadre_array",
      "squadreSize",
    ]),
  },
  mounted() {
    console.log("--> AstaTavoloGriglia ready.");
  },
  destroyed() {
    console.log("<-- AstaTavoloGriglia destroyed.");
  },
};
</script>
<style lang="scss" scoped>
@import "../main.scss";

.asta-tavolo-griglia {
  .calciatore {
    max-width: 230px;
    margin: 0 auto 10px;
  }
  .lista-squadre {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .ghost {
    box-shadow: 0 0 0px 1px var(--v-navy-base);
    border-radius: 10px;
  }
}

</style>
